import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { LocationService } from '../../../services/location.service';
import { DataTransferService } from '../../../services/DataTransferService';
import { Router } from '@angular/router';
import { TableService } from '../../../services/table.service';
import { UserService } from '../../../services/usre.service';

@Component({
  selector: 'app-entity-selection',
  templateUrl: './entity-selection.component.html',
  styleUrls: ['./entity-selection.component.scss']
})
export class EntitySelectionComponent implements OnInit {

  companies = [];
  originalCompanies = [];
  targetCompamies = [];
  searchTerm = '';

  constructor(
    private userContext: TableService,
    private locationService: LocationService,
    private dataTransfer: DataTransferService,
    private user: UserService,
    private router: Router) {
    this.locationService.getUserCompaniesAndLocations((res) => {
      this.companies = res;
      this.originalCompanies = res;
      if (this.companies != undefined) {
        if (this.companies.length == 1) {
          this.setCompany(this.companies[0]);
          this.router.navigate(['/dashboard']);
          this.userLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
          this.getCurrentUser();
        }
      }
      else {
        var exsistCompany = JSON.parse(sessionStorage.getItem('company')) as any;
        this.userLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;

        if (exsistCompany != undefined) {
          this.companies = exsistCompany;
          this.setCompany(this.companies);
        }
      }
      var counter = 1
      this.companies.map((item, i) => {
        item.backgroundItem = counter++;
        if (counter == 4)
          counter = 1;
      })
    }, (err) => {
    });
  }

  currentUser: any = {};
  userLocationId: any;
  getCurrentUser() {
    this.currentUser = this.user.getCurrentUser((suc) => {
      this.currentUser = suc;
      this.userContext.getRow('GET_USER', this.userLocationId, (res) => {
        this.currentUser.Roles = res.Roles;
        this.currentUser.Settings = res.Settings;
        this.dataTransfer.setUser(this.currentUser)

      }, (res) => { })
    }, (err) => { });
  }

  setCompany(company) {
    this.dataTransfer.setCompany(company);
    this.userLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    this.getCurrentUser();
    this.router.navigate(['/dashboard']);
  }

  search(e) {
    if ((e.keyCode <= 90 && e.keyCode >= 48) || (e.keyCode <= 105 && e.keyCode >= 96) || e.keyCode == 8) {
      this.companies = this.originalCompanies;

      if (this.searchTerm != "" && this.searchTerm != null) {
        this.targetCompamies = this.companies.filter(x => x.BranchCompanyName.toLowerCase().startsWith(this.searchTerm.toLocaleLowerCase()));
        this.companies = this.targetCompamies
      }
      else
        this.companies = this.originalCompanies;
    }
  }

  ngOnInit() {
  }
}
